/**
 * Generated runtime TestId mirror for frontend/src/features/inbound-connectors/components/SyncRunsTab.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const SyncRunsTabTestIds = {
  cardTitleSyncErrorLogs: "card-title-sync-error-logs",
  cardTitleSyncRecords: "card-title-sync-records",
  colErrorLogCreatedAt: "col-error-log-created-at",
  colErrorLogId: "col-error-log-id",
  colSyncRecordAction: "col-sync-record-action",
  colSyncRecordCorrelatedIdentity: "col-sync-record-correlated-identity",
  colSyncRecordEntityType: "col-sync-record-entity-type",
  colSyncRecordErrorMessage: "col-sync-record-error-message",
  colSyncRecordExternalId: "col-sync-record-external-id",
  colSyncRecordPayload: "col-sync-record-payload",
  colSyncRecordProcessedAt: "col-sync-record-processed-at",
  colSyncRunCreated: "col-sync-run-created",
  colSyncRunDuration: "col-sync-run-duration",
  colSyncRunErrored: "col-sync-run-errored",
  colSyncRunSkipped: "col-sync-run-skipped",
  colSyncRunStarted: "col-sync-run-started",
  colSyncRunStatus: "col-sync-run-status",
  colSyncRunType: "col-sync-run-type",
  colSyncRunUpdated: "col-sync-run-updated",
  syncRunDetail: "sync-run-detail",
  syncRunsCard: "sync-runs-card",
  syncRunsEmpty: "sync-runs-empty",
  syncRunsLoading: "sync-runs-loading",
  approveDialog: (run_syncRunId: string) => `approve-dialog-${run_syncRunId}`,
  approveDialogPrefix: () => "approve-dialog-" as TestIdPrefix,
  btnApprove: (run_syncRunId: string) => `btn-approve-${run_syncRunId}`,
  btnApprovePrefix: () => "btn-approve-" as TestIdPrefix,
  btnReject: (run_syncRunId: string) => `btn-reject-${run_syncRunId}`,
  btnRejectPrefix: () => "btn-reject-" as TestIdPrefix,
  btnTogglePayload: (record_id: string) => `btn-toggle-payload-${record_id}`,
  btnTogglePayloadPrefix: () => "btn-toggle-payload-" as TestIdPrefix,
  errorLogLink: (ref_errorLogId: string) => `error-log-link-${ref_errorLogId}`,
  errorLogLinkPrefix: () => "error-log-link-" as TestIdPrefix,
  errorLogRef: (ref_errorLogId: string) => `error-log-ref-${ref_errorLogId}`,
  errorLogRefPrefix: () => "error-log-ref-" as TestIdPrefix,
  mapped: (record_id: string) => `mapped-${record_id}`,
  mappedPrefix: () => "mapped-" as TestIdPrefix,
  pausedActions: (run_syncRunId: string) => `paused-actions-${run_syncRunId}`,
  pausedActionsPrefix: () => "paused-actions-" as TestIdPrefix,
  raw: (record_id: string) => `raw-${record_id}`,
  rawPrefix: () => "raw-" as TestIdPrefix,
  rejectDialog: (run_syncRunId: string) => `reject-dialog-${run_syncRunId}`,
  rejectDialogPrefix: () => "reject-dialog-" as TestIdPrefix,
  syncRecordIdentity: (record_id: string) => `sync-record-identity-${record_id}`,
  syncRecordIdentityPrefix: () => "sync-record-identity-" as TestIdPrefix,
  syncRecordPayload: (record_id: string) => `sync-record-payload-${record_id}`,
  syncRecordPayloadPrefix: () => "sync-record-payload-" as TestIdPrefix,
  syncRecordRow: (record_id: string) => `sync-record-row-${record_id}`,
  syncRecordRowPrefix: () => "sync-record-row-" as TestIdPrefix,
  syncRecordsCard: (run_syncRunId: string) => `sync-records-card-${run_syncRunId}`,
  syncRecordsCardPrefix: () => "sync-records-card-" as TestIdPrefix,
  syncRecordsEmpty: (run_syncRunId: string) => `sync-records-empty-${run_syncRunId}`,
  syncRecordsEmptyPrefix: () => "sync-records-empty-" as TestIdPrefix,
  syncRecordsFilter: (run_syncRunId: string) => `sync-records-filter-${run_syncRunId}`,
  syncRecordsFilterPrefix: () => "sync-records-filter-" as TestIdPrefix,
  syncRunErrorLogsCard: (runId: string) => `sync-run-error-logs-card-${runId}`,
  syncRunErrorLogsCardPrefix: () => "sync-run-error-logs-card-" as TestIdPrefix,
  syncRunErrorLogsCount: (runId: string) => `sync-run-error-logs-count-${runId}`,
  syncRunErrorLogsCountPrefix: () => "sync-run-error-logs-count-" as TestIdPrefix,
  syncRunErrorLogsEmpty: (runId: string) => `sync-run-error-logs-empty-${runId}`,
  syncRunErrorLogsEmptyPrefix: () => "sync-run-error-logs-empty-" as TestIdPrefix,
  syncRunRow: (run_syncRunId: string) => `sync-run-row-${run_syncRunId}`,
  syncRunRowPrefix: () => "sync-run-row-" as TestIdPrefix
} as const;
